module.exports = __webpack_public_path__ + "static/media/spenmo-icon-bordered.72b25991.svg";